// deep-compare + diff
function isIsoDateString(value: any): boolean {
    return typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/.test(value);
}

function toComparable(val: any): any {
    if (val instanceof Date) return val.toISOString();
    if (isIsoDateString(val)) return new Date(val).toISOString();
    return val;
}

function deepEqual(a: any, b: any): boolean {
    a = toComparable(a);
    b = toComparable(b);

    if (a === b) return true;

    if (a == null || b == null) return a === b;

    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i])) return false;
        }
        return true;
    }

    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }

    if (typeof a === "object" && typeof b === "object") {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys) {
            if (!bKeys.includes(key)) return false;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }

    return false;
}

/**
 * Возвращает объект, содержащий только те поля из `updated`, которые отличаются от `original`.
 * Работает рекурсивно для объектов/массивов, корректно сравнивает Dates и ISO-строки.
 */
export function getChangedFields<T extends object>(original: Partial<T>, updated: Partial<T>): Partial<T> {
    const diff: any = {};

    for (const key of Object.keys(updated) as (keyof T)[]) {
        const newVal = (updated as any)[key];
        const oldVal = (original as any)[key];

        // если оба undefined — игнорируем
        if (newVal === undefined && oldVal === undefined) continue;

        // если один из них undefined (поле добавлено/удалено) — считаем изменённым
        if (oldVal === undefined && newVal !== undefined) {
            diff[key] = newVal;
            continue;
        }
        if (oldVal !== undefined && newVal === undefined) {
            diff[key] = newVal; // если нужно сигнализировать об удалении — сохраняем undefined
            continue;
        }

        // глубокое сравнение
        if (!deepEqual(oldVal, newVal)) {
            diff[key] = newVal;
        }
    }

    return diff;
}
